import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, children, boxClassName = '', showCloseButton = true }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop" role="presentation">
      <div
        className={`modal-box ${boxClassName}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="modal-header">
          <h3>{title}</h3>
          {showCloseButton ? (
            <button onClick={onClose} className="modal-close">&times;</button>
          ) : null}
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
